<script setup lang="ts">
import { computed, reactive, ref } from 'vue'
import { api, ApiError } from '../api.js'

const props = defineProps<{ initialized: boolean; initKey: string }>()
const emit = defineEmits<{ authenticated: [account: string] }>()
const form = reactive({ account: '', accountRepeat: '', password: '', passwordRepeat: '' })
const error = ref('')
const busy = ref(false)
const validPassword = computed(() => form.password.length >= 6)

async function submit() {
  error.value = ''
  if (!props.initialized && form.account !== form.accountRepeat) return void (error.value = '两次账号不一致')
  if (!props.initialized && form.password !== form.passwordRepeat) return void (error.value = '两次密码不一致')
  if (!props.initialized && !validPassword.value) return void (error.value = '密码至少 6 位，纯数字也可以')
  busy.value = true
  try {
    const result = props.initialized
      ? await api<{ account: string }>('/api/login', { method: 'POST', body: JSON.stringify({ account: form.account, password: form.password, deviceLabel: navigator.userAgent.slice(0, 90) }) })
      : await api<{ account: string }>('/api/setup', { method: 'POST', headers: { 'X-Initialization-Key': props.initKey }, body: JSON.stringify({ ...form, deviceLabel: navigator.userAgent.slice(0, 90) }) })
    emit('authenticated', result.account)
  } catch (reason) { error.value = (reason as ApiError).message } finally { busy.value = false }
}
</script>

<template>
  <main class="auth-shell">
    <section class="auth-card">
      <div class="brand-mark">早</div>
      <p class="eyebrow">ZAO CAN LEDGER</p>
      <h1>{{ initialized ? '欢迎回来' : '开一本早餐账' }}</h1>
      <p class="subtle">{{ initialized ? '使用共用账号继续记账' : '一次初始化，两台设备共用同一本账' }}</p>
      <form class="auth-form" @submit.prevent="submit">
        <label>账号<input v-model.trim="form.account" autocomplete="username" autocapitalize="none" placeholder="例如 aaa" required /></label>
        <label v-if="!initialized">重复账号<input v-model.trim="form.accountRepeat" autocomplete="off" autocapitalize="none" required /></label>
        <label>密码<input v-model="form.password" type="password" :autocomplete="initialized ? 'current-password' : 'new-password'" :minlength="initialized ? undefined : 6" maxlength="128" required /></label>
        <label v-if="!initialized">重复密码<input v-model="form.passwordRepeat" type="password" autocomplete="new-password" required /></label>
        <p v-if="!initialized" class="password-meter" :class="{ okay: validPassword }">{{ validPassword ? '密码长度符合要求' : '至少 6 位，纯数字也可以' }}</p>
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
        <button class="primary-button" :disabled="busy">{{ busy ? '请稍候…' : initialized ? '登录' : '创建并进入账本' }}</button>
      </form>
      <p v-if="!initialized && !initKey" class="credential-note">当前链接缺少一次性初始化凭证，请使用部署时生成的初始化链接。</p>
    </section>
  </main>
</template>
